var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('el-row',{staticClass:"menu-container"},[_c('el-col',{staticClass:"section-black",attrs:{"span":10}},[_vm._v("\n      NEGRO\n    ")]),_vm._v(" "),_c('el-col',{staticClass:"section-white",attrs:{"span":14}},[_vm._v("\n      BLANCO\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2ad64a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu-home.vue
// module id = null
// module chunks = 